// extracted by mini-css-extract-plugin
export default {"root":"SubtopicsList_root__wEgQM","collection":"SubtopicsList_collection__v7L-u","block":"SubtopicsList_block__OKCGY"};